import { ApplicationConfig, ErrorHandler, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import {  provideHttpClient, withInterceptors } from '@angular/common/http';
import { jwtInterceptor } from './core/interceptors/jwt.interceptor';
import { GlobalErrorHandlingService } from './shared/components/globalexception/global-error-handling.service';
import { AesEncDecService } from './core/services/aes/aes-enc-dec.service';
import { authInterceptor } from './core/interceptors/auth.interceptor';
import { networkInterceptor } from './core/interceptors/network.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
     provideHttpClient(withInterceptors([networkInterceptor,jwtInterceptor, authInterceptor]))
     
     
    // provideHttpClient(withInterceptors([ jwtInterceptor]))
  
    , provideZoneChangeDetection({ eventCoalescing: true })
    , provideRouter(routes),
    
     provideAnimationsAsync(),{
      provide: ErrorHandler,
      useClass: GlobalErrorHandlingService
    }, provideAnimationsAsync(), provideAnimationsAsync()]
};
